<div class="change-log">
  <markdown [src]="'assets/changelog/CHANGELOG.md'"></markdown>
</div>
